import { IPartnerConfigsLoader } from "../types/IPartnerConfigsLoader.types";
import {
    IBaseConfig,
    IMapQueryConfig,
    IMapQueryItem,
} from "../types/IGameLoader.types";
import { IConfigs } from "../types/IConfigs.types";
import { loadXML } from "../utils";
import { parseFiltersConfigs } from "../../utils/parseFiltersConfigs";
import { parseMapQueryParams } from "../../utils/parseMapQueryParams";

export class PartnerConfigsLoader implements IPartnerConfigsLoader {
    configDocument: Document | undefined;
    filters: Map<string, IBaseConfig> | undefined;
    mapQueryParams: { [index: string]: IMapQueryItem } = {};

    constructor(public configs: IConfigs, public partner: string | undefined, public altPartner: string | undefined) {}

    async load(revision: string): Promise<void> {
        const loadedOriginalPartner = await this.checkAndLoadPartner(this.partner, revision);
        if (loadedOriginalPartner) {
            return;
        }

        await this.checkAndLoadPartner(this.altPartner, revision);
    }

    prepare(gameName: string): {
        filters: Map<string, IBaseConfig>;
        mapQuery: IMapQueryConfig;
    } {
        if (!this.configDocument) {
            throw new Error(`Partner config "${this.partner}" doesn't exist`);
        }

        this.filters = parseFiltersConfigs(this.configDocument);
        this.mapQueryParams = parseMapQueryParams(this.configDocument);

        return {
            filters: this.filters,
            mapQuery: this.mapQueryParams,
        };
    }

    async loadAndParseFile(filepath: string): Promise<void> {
        this.configDocument = await loadXML(filepath);
    }

    protected generateFilePath(partner: string, revision: string): string {
        return `${this.configs.getPrefixXmlFolder()}/partners/${partner}.xml?_=${revision}`;
    }

    protected async checkAndLoadPartner(partner: string | undefined, revision: string): Promise<boolean> {
        if (!partner) {
            return false;
        }

        const filepath = this.generateFilePath(partner, revision);
        try {
            await this.loadAndParseFile(filepath);

            return true;
        } catch (e: any) {
            console.warn(`Partner config could not be loaded! ${e.message}`);

            return false;
        }
    }
}
